// import { useState } from 'react'
// import { motion } from 'framer-motion'
// import { Search, Filter, Award, BookOpen, Clock, Users, Star, ChevronRight, Target, Zap, ChevronLeft, Play, Headphones } from 'lucide-react'
// import CourseCard from '../components/CourseCard'
// import { courses } from '../data/mockData'
// import { useNavigate } from 'react-router-dom'
// import useStore from '../store/useStore'

// const courseCategories = [
//   'All', 'Technology & AI', 'Business & Entrepreneurship', 'Creative Arts', 
//   'Personal Development', 'Science & Innovation', 'Health & Wellness', 
//   'History & Culture', 'Skills & Hobbies'
// ]

// const courseTiers = ['All', 'Free', 'Plus', 'Pro']

// // Enhanced Learning Paths to match Podcast Series style
// const learningPaths = [
//   {
//     id: 1,
//     title: 'AI & Machine Learning Mastery',
//     description: 'From fundamentals to advanced AI applications and real-world implementations',
//     category: 'Technology & AI',
//     courses: [101, 102],
//     duration: '14 weeks',
//     level: 'Beginner to Advanced',
//     image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=400&h=250&fit=crop',
//     color: 'from-blue-500 to-purple-600',
//     rating: 4.9,
//     studentCount: 2500,
//     modules: ['AI Fundamentals', 'Neural Networks', 'Deep Learning', 'Real-world Projects'],
//     learningObjectives: [
//       'Master AI fundamentals and key concepts',
//       'Build and train neural networks',
//       'Implement deep learning models',
//       'Deploy AI solutions in production'
//     ]
//   },
//   {
//     id: 2,
//     title: 'Web Development Bootcamp',
//     description: 'Build modern web applications with React and full-stack technologies from scratch',
//     category: 'Technology & AI',
//     courses: [103, 101],
//     duration: '12 weeks',
//     level: 'Beginner to Intermediate',
//     image: 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=400&h=250&fit=crop',
//     color: 'from-green-500 to-teal-600',
//     rating: 4.8,
//     studentCount: 3200,
//     modules: ['HTML/CSS', 'JavaScript', 'React', 'Backend Development', 'Deployment'],
//     learningObjectives: [
//       'Create responsive web designs',
//       'Master React and modern JavaScript',
//       'Build RESTful APIs',
//       'Deploy full-stack applications'
//     ]
//   },
//   {
//     id: 3,
//     title: 'Startup Entrepreneurship',
//     description: 'Launch and scale your business idea with proven strategies and frameworks',
//     category: 'Business & Entrepreneurship', 
//     courses: [104, 105],
//     duration: '10 weeks',
//     level: 'All Levels',
//     image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=250&fit=crop',
//     color: 'from-orange-500 to-red-600',
//     rating: 4.7,
//     studentCount: 1800,
//     modules: ['Idea Validation', 'Business Planning', 'Funding Strategies', 'Growth Hacking'],
//     learningObjectives: [
//       'Validate business ideas effectively',
//       'Create compelling business plans',
//       'Secure funding from investors',
//       'Scale your startup successfully'
//     ]
//   },
//   {
//     id: 4,
//     title: 'Digital Creative Suite',
//     description: 'Master design, music, and content creation with industry-standard tools',
//     category: 'Creative Arts',
//     courses: [106, 107],
//     duration: '10 weeks',
//     level: 'Beginner to Intermediate',
//     image: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=250&fit=crop',
//     color: 'from-purple-500 to-pink-600',
//     rating: 4.8,
//     studentCount: 2100,
//     modules: ['Graphic Design', 'Audio Production', 'Video Editing', 'Content Strategy'],
//     learningObjectives: [
//       'Master design principles and tools',
//       'Produce professional audio content',
//       'Edit engaging video content',
//       'Develop content marketing strategies'
//     ]
//   },
//   {
//     id: 5,
//     title: 'Personal Productivity System',
//     description: 'Build habits and systems for success in personal and professional life',
//     category: 'Personal Development',
//     courses: [108, 110],
//     duration: '8 weeks',
//     level: 'All Levels',
//     image: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop',
//     color: 'from-indigo-500 to-blue-600',
//     rating: 4.6,
//     studentCount: 2900,
//     modules: ['Time Management', 'Goal Setting', 'Habit Formation', 'Work-Life Balance'],
//     learningObjectives: [
//       'Master time management techniques',
//       'Set and achieve meaningful goals',
//       'Build sustainable habits',
//       'Maintain work-life harmony'
//     ]
//   },
//   {
//     id: 6,
//     title: 'Data Science Fundamentals',
//     description: 'Learn data analysis, visualization, and machine learning from scratch',
//     category: 'Technology & AI',
//     courses: [101, 102, 103],
//     duration: '16 weeks',
//     level: 'Beginner to Intermediate',
//     image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop',
//     color: 'from-teal-500 to-cyan-600',
//     rating: 4.9,
//     studentCount: 3400,
//     modules: ['Data Analysis', 'Statistics', 'Visualization', 'Machine Learning'],
//     learningObjectives: [
//       'Analyze and clean complex datasets',
//       'Apply statistical methods',
//       'Create insightful visualizations',
//       'Implement machine learning models'
//     ]
//   },
//   {
//     id: 7,
//     title: 'Digital Marketing Mastery',
//     description: 'Master online marketing strategies across all major platforms',
//     category: 'Business & Entrepreneurship',
//     courses: [104, 105, 106],
//     duration: '9 weeks',
//     level: 'All Levels',
//     image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop',
//     color: 'from-yellow-500 to-orange-600',
//     rating: 4.7,
//     studentCount: 2700,
//     modules: ['SEO', 'Social Media', 'Content Marketing', 'Analytics'],
//     learningObjectives: [
//       'Optimize websites for search engines',
//       'Create viral social media campaigns',
//       'Develop content strategies',
//       'Analyze marketing performance'
//     ]
//   },
//   {
//     id: 8,
//     title: 'Financial Literacy & Investment',
//     description: 'Build wealth and financial security through smart investment strategies',
//     category: 'Personal Development',
//     courses: [108, 109, 110],
//     duration: '11 weeks',
//     level: 'Beginner to Advanced',
//     image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=250&fit=crop',
//     color: 'from-emerald-500 to-green-600',
//     rating: 4.8,
//     studentCount: 2300,
//     modules: ['Budgeting', 'Investing', 'Retirement Planning', 'Tax Strategies'],
//     learningObjectives: [
//       'Create and maintain budgets',
//       'Invest in stocks and bonds',
//       'Plan for retirement',
//       'Optimize tax strategies'
//     ]
//   }
// ]

// const categoryTopics = {
//   'Technology & AI': [
//     { name: 'Programming', courseCount: 12 },
//     { name: 'AI/ML', courseCount: 8 },
//     { name: 'Cybersecurity', courseCount: 6 },
//     { name: 'Web Development', courseCount: 10 },
//     { name: 'Data Science', courseCount: 7 },
//     { name: 'Cloud Computing', courseCount: 5 }
//   ],
//   'Business & Entrepreneurship': [
//     { name: 'Startups', courseCount: 8 },
//     { name: 'Marketing', courseCount: 6 },
//     { name: 'Finance', courseCount: 5 },
//     { name: 'Leadership', courseCount: 4 },
//     { name: 'Sales', courseCount: 3 },
//     { name: 'Strategy', courseCount: 4 }
//   ],
//   'Creative Arts': [
//     { name: 'Design', courseCount: 7 },
//     { name: 'Music Production', courseCount: 4 },
//     { name: 'Writing', courseCount: 6 },
//     { name: 'Filmmaking', courseCount: 3 },
//     { name: 'Photography', courseCount: 4 },
//     { name: 'Digital Art', courseCount: 5 }
//   ],
//   'Personal Development': [
//     { name: 'Productivity', courseCount: 5 },
//     { name: 'Mindfulness', courseCount: 4 },
//     { name: 'Communication', courseCount: 6 },
//     { name: 'Habits', courseCount: 3 },
//     { name: 'Leadership', courseCount: 4 },
//     { name: 'Time Management', courseCount: 4 }
//   ]
// }

// function LearningHub() {
//   const navigate = useNavigate()
//   const { user } = useStore()
//   const [searchTerm, setSearchTerm] = useState('')
//   const [selectedLevel, setSelectedLevel] = useState('All')
//   const [selectedTier, setSelectedTier] = useState('All')
//   const [selectedCategory, setSelectedCategory] = useState('All')
//   const [showAdvancedFilters, setShowAdvancedFilters] = useState(false)
//   const [certificationOnly, setCertificationOnly] = useState(false)
//   const [selectedTopics, setSelectedTopics] = useState([])
//   const [sortBy, setSortBy] = useState('mostPopular')

//   const levels = ['All', 'Beginner', 'Intermediate', 'Advanced']

//   const filteredCourses = courses.filter((course) => {
//     const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       course.description.toLowerCase().includes(searchTerm.toLowerCase())
//     const matchesLevel = selectedLevel === 'All' || course.skillLevel === selectedLevel
//     const matchesTier = selectedTier === 'All' || course.tier === selectedTier.toLowerCase()
//     const matchesCategory = selectedCategory === 'All' || course.category === selectedCategory
//     const matchesCertification = !certificationOnly || course.hasCertificate
//     const matchesTopics = selectedTopics.length === 0 || 
//       selectedTopics.some(topic => course.topics?.includes(topic))

//     return matchesSearch && matchesLevel && matchesTier && matchesCategory && matchesCertification && matchesTopics
//   })

//   const sortedCourses = [...filteredCourses].sort((a, b) => {
//     switch (sortBy) {
//       case 'mostPopular':
//         return (b.students || 0) - (a.students || 0)
//       case 'highestRated':
//         return (b.rating || 0) - (a.rating || 0)
//       case 'newest':
//         return new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
//       case 'duration':
//         const getDurationValue = (duration) => {
//           const match = duration.match(/\d+/)
//           return match ? parseInt(match[0]) : 0
//         }
//         return getDurationValue(b.duration) - getDurationValue(a.duration)
//       default:
//         return 0
//     }
//   })

//   const toggleTopic = (topic) => {
//     setSelectedTopics(prev => 
//       prev.includes(topic) 
//         ? prev.filter(t => t !== topic)
//         : [...prev, topic]
//     )
//   }

//   const clearAllFilters = () => {
//     setSearchTerm('')
//     setSelectedLevel('All')
//     setSelectedTier('All')
//     setSelectedCategory('All')
//     setCertificationOnly(false)
//     setSelectedTopics([])
//     setShowAdvancedFilters(false)
//     setSortBy('mostPopular')
//   }

//   const filteredLearningPaths = selectedCategory === 'All' 
//     ? learningPaths 
//     : learningPaths.filter(path => path.category === selectedCategory)

//   const handleExplorePath = (path) => {
//     if (!user) {
//       localStorage.setItem('lastVisitedPage', '/courses')
//       navigate('/auth')
//       return
//     }
//     navigate(`/learning-path/${path.id}`)
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 py-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6">
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="mb-12"
//         >
//           <div className="bg-gradient-to-br from-primary to-accent rounded-2xl p-8 md:p-12 text-white mb-8">
//             <h1 className="text-4xl md:text-5xl font-bold mb-4">
//               Learning Hub
//             </h1>
//             <p className="text-xl text-purple-100 mb-6 max-w-3xl">
//               Master new skills across 8 comprehensive domains. From AI to wellness, find your perfect learning journey.
//             </p>
//             <div className="flex flex-wrap gap-4">
//               <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
//                 <BookOpen className="w-5 h-5" />
//                 <span className="font-medium">{courses.length}+ Courses</span>
//               </div>
//               <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
//                 <Award className="w-5 h-5" />
//                 <span className="font-medium">Certifications Available</span>
//               </div>
//               <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
//                 <Users className="w-5 h-5" />
//                 <span className="font-medium">10K+ Students</span>
//               </div>
//               <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
//                 <Target className="w-5 h-5" />
//                 <span className="font-medium">{learningPaths.length} Learning Paths</span>
//               </div>
//             </div>
//           </div>

//           <div className="flex flex-col sm:flex-row gap-4">
//             <button
//               onClick={() => navigate('/ambassador-program')}
//               className="flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-primary to-accent text-white rounded-lg font-semibold hover:shadow-lg transition-all duration-200"
//             >
//               <Award className="w-5 h-5" />
//               <span>Apply for Ambassador Program</span>
//             </button>
//           </div>
//         </motion.div>

//         <div className="bg-white rounded-xl shadow-md p-6 mb-8">
//           <div className="flex flex-col md:flex-row gap-4 mb-4">
//             <div className="flex-1 relative">
//               <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search courses across all categories..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//               />
//             </div>
//             <button
//               onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
//               className="flex items-center justify-center space-x-2 px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200"
//             >
//               <Filter className="w-5 h-5 text-gray-600" />
//               <span className="font-medium text-gray-700">Advanced Filters</span>
//             </button>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
//               <select
//                 value={selectedCategory}
//                 onChange={(e) => setSelectedCategory(e.target.value)}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//               >
//                 {courseCategories.map((category) => (
//                   <option key={category} value={category}>
//                     {category}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Difficulty</label>
//               <select
//                 value={selectedLevel}
//                 onChange={(e) => setSelectedLevel(e.target.value)}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//               >
//                 {levels.map((level) => (
//                   <option key={level} value={level}>
//                     {level}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Subscription Tier</label>
//               <select
//                 value={selectedTier}
//                 onChange={(e) => setSelectedTier(e.target.value)}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//               >
//                 {courseTiers.map((tier) => (
//                   <option key={tier} value={tier}>
//                     {tier}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {showAdvancedFilters && (
//             <motion.div
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: 'auto' }}
//               className="border-t pt-4 space-y-4"
//             >
//               <div className="flex items-center space-x-2">
//                 <input
//                   type="checkbox"
//                   id="certification-only"
//                   checked={certificationOnly}
//                   onChange={(e) => setCertificationOnly(e.target.checked)}
//                   className="rounded border-gray-300 text-primary focus:ring-primary"
//                 />
//                 <label htmlFor="certification-only" className="text-sm font-medium text-gray-700">
//                   Show only courses with certification
//                 </label>
//               </div>

//               {selectedCategory !== 'All' && categoryTopics[selectedCategory] && (
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Topics in {selectedCategory}
//                   </label>
//                   <div className="flex flex-wrap gap-2">
//                     {categoryTopics[selectedCategory].map((topic) => (
//                       <button
//                         key={topic.name}
//                         onClick={() => toggleTopic(topic.name)}
//                         className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
//                           selectedTopics.includes(topic.name)
//                             ? 'bg-primary text-white shadow-md'
//                             : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                         }`}
//                       >
//                         {topic.name} ({topic.courseCount})
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </motion.div>
//           )}

//           {(selectedLevel !== 'All' || selectedTier !== 'All' || selectedCategory !== 'All' || certificationOnly || selectedTopics.length > 0) && (
//             <div className="flex items-center justify-between pt-4 border-t">
//               <div className="flex items-center space-x-2">
//                 <span className="text-sm text-gray-600">Active filters:</span>
//                 {selectedLevel !== 'All' && (
//                   <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">Level: {selectedLevel}</span>
//                 )}
//                 {selectedTier !== 'All' && (
//                   <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded">Tier: {selectedTier}</span>
//                 )}
//                 {selectedCategory !== 'All' && (
//                   <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded">Category: {selectedCategory}</span>
//                 )}
//                 {certificationOnly && (
//                   <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs rounded">Certification Only</span>
//                 )}
//                 {selectedTopics.map(topic => (
//                   <span key={topic} className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded">Topic: {topic}</span>
//                 ))}
//               </div>
//               <button
//                 onClick={clearAllFilters}
//                 className="text-sm text-primary hover:text-primary/80 font-medium"
//               >
//                 Clear all
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Enhanced Learning Paths Section - Matching Podcast Series Style */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="mb-12"
//         >
//           <div className="flex items-center justify-between mb-6">
//             <div>
//               <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
//                 {selectedCategory === 'All' ? 'Featured Learning Paths' : `${selectedCategory} Learning Paths`}
//               </h2>
//               <p className="text-gray-600">
//                 {selectedCategory === 'All' 
//                   ? 'Follow curated paths to master specific skills with structured learning' 
//                   : `Structured learning journeys in ${selectedCategory}`
//                 }
//               </p>
//             </div>
//             <button 
//   onClick={() => navigate('/learning-paths')}
//   className="text-primary font-medium hover:underline"
// >
//   View All Paths
// </button>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {filteredLearningPaths.map((path) => (
//               <motion.div
//                 key={path.id}
//                 whileHover={{ y: -4 }}
//                 className={`bg-gradient-to-br ${path.color} rounded-xl p-6 text-white hover:shadow-xl transition-all duration-300 cursor-pointer group relative min-h-[300px] flex flex-col`}
//                 onClick={() => handleExplorePath(path)}
//               >
//                 <div className="flex-1 flex flex-col">
//                   {/* Image Container - Keeps the learning path images */}
//                   <div className="relative h-32 mb-4 overflow-hidden rounded-lg">
//                     <img 
//                       src={path.image} 
//                       alt={path.title}
//                       className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
//                     <div className="absolute bottom-2 left-3">
//                       <span className="px-2 py-1 bg-black/50 backdrop-blur-sm text-xs font-medium rounded">
//                         {path.courses.length} courses
//                       </span>
//                     </div>
//                   </div>
                  
//                   <div className="flex items-center space-x-3 mb-3">
//                     <Target className="w-5 h-5 text-white/90 flex-shrink-0" />
//                     <h3 className="text-lg font-bold line-clamp-1" title={path.title}>
//                       {path.title}
//                     </h3>
//                   </div>
                  
//                   <div className="mb-4 flex-1">
//                     <p className="text-white/90 text-sm line-clamp-2">
//                       {path.description}
//                     </p>
//                   </div>
                  
//                   <div className="space-y-2 mb-4">
//                     <div className="flex items-center space-x-2 text-xs text-white/80">
//                       <Clock className="w-3.5 h-3.5 flex-shrink-0" />
//                       <span>{path.duration}</span>
//                     </div>
//                     <div className="flex items-center space-x-2 text-xs text-white/80">
//                       <Zap className="w-3.5 h-3.5 flex-shrink-0" />
//                       <span>{path.level}</span>
//                     </div>
//                     <div className="flex items-center space-x-2 text-xs text-white/80">
//                       <Star className="w-3.5 h-3.5 flex-shrink-0 fill-current" />
//                       <span>{path.rating} ({path.studentCount?.toLocaleString()} students)</span>
//                     </div>
//                   </div>
//                 </div>
                
//                 <div className="mt-auto pt-4">
//                   <button 
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleExplorePath(path);
//                     }}
//                     className="w-full flex items-center justify-center space-x-2 py-2 bg-white/20 rounded-lg hover:bg-white/30 transition-colors duration-200 backdrop-blur-sm"
//                   >
//                     <BookOpen className="w-4 h-4" />
//                     <span>Explore Path</span>
//                   </button>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>

//         {/* Courses Grid Header */}
//         <div className="mb-6">
//           <div className="flex items-center justify-between">
//             <p className="text-gray-600">
//               Showing <span className="font-semibold">{sortedCourses.length}</span> course{sortedCourses.length !== 1 ? 's' : ''}
//               {selectedCategory !== 'All' && ` in ${selectedCategory}`}
//             </p>
//             <div className="flex items-center space-x-4">
//               <span className="text-sm text-gray-600">Sort by:</span>
//               <select 
//                 value={sortBy}
//                 onChange={(e) => setSortBy(e.target.value)}
//                 className="text-sm border border-gray-300 rounded-lg px-3 py-1 focus:outline-none focus:ring-2 focus:ring-primary"
//               >
//                 <option value="mostPopular">Most Popular</option>
//                 <option value="highestRated">Highest Rated</option>
//                 <option value="newest">Newest</option>
//                 <option value="duration">Duration</option>
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Courses Grid using CourseCard */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
//           {sortedCourses.map((course) => (
//             <CourseCard key={course.id} course={course} />
//           ))}
//         </div>

//         {sortedCourses.length === 0 && (
//           <div className="text-center py-16">
//             <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
//               <Search className="w-12 h-12 text-gray-400" />
//             </div>
//             <h3 className="text-2xl font-bold text-gray-900 mb-2">No courses found</h3>
//             <p className="text-gray-600 mb-6">Try adjusting your search or filter criteria</p>
//             <button
//               onClick={clearAllFilters}
//               className="px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors duration-200"
//             >
//               Clear All Filters
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   )
// }

// export default LearningHub

// src/pages/LearningHub.jsx
import { useState } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Target, Clock, Zap, AlertCircle, Mail, CheckCircle, Headphones } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useStore from '../store/useStore';

function LearningHub() {
  const navigate = useNavigate();
  const { user } = useStore();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleNotifyMe = async (e) => {
    e.preventDefault();
    setError('');
    
    const subscribeEmail = email || user?.email;
    
    if (!subscribeEmail) {
      setError('Please enter your email address');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(subscribeEmail)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    
    try {
      // Try the primary endpoint first
      const response = await fetch('/api/v2/admin/email-api.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'learning-hub-notify',
          email: subscribeEmail,
          name: user?.name || '',
          user_id: user?.id || null
        })
      });

      const data = await response.json();
      
      if (data.success) {
        setSubscribed(true);
        setEmail('');
        
        setTimeout(() => {
          setSubscribed(false);
        }, 5000);
      } else {
        // If primary fails, try the backup endpoint
        console.log('Primary endpoint failed, trying backup...');
        await tryBackupEndpoint(subscribeEmail);
      }
      
    } catch (error) {
      console.log('Primary endpoint error, trying backup...', error);
      await tryBackupEndpoint(subscribeEmail);
    } finally {
      setLoading(false);
    }
  };

  const tryBackupEndpoint = async (subscribeEmail) => {
    try {
      const backupResponse = await fetch('/api/v2/admin/learning-hub-backup.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: subscribeEmail,
          name: user?.name || '',
          user_id: user?.id || null
        })
      });
      
      const backupData = await backupResponse.json();
      
      if (backupData.success) {
        setSubscribed(true);
        setEmail('');
        
        setTimeout(() => {
          setSubscribed(false);
        }, 5000);
      } else {
        throw new Error(backupData.error || 'Backup failed');
      }
    } catch (backupError) {
      setError('Failed to subscribe. Please try again later.');
      console.error('Both endpoints failed:', backupError);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-600 rounded-2xl p-8 md:p-12 text-white mb-8 shadow-xl">
            <div className="flex items-center justify-center gap-3 mb-6">
              <BookOpen className="w-10 h-10" />
              <h1 className="text-4xl md:text-5xl font-bold">Learning Hub</h1>
            </div>
            
            <div className="mb-8">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-4">
                <AlertCircle className="w-6 h-6" />
                <span className="text-lg font-semibold">Coming Soon - 2026</span>
              </div>
              <p className="text-xl text-blue-100 mb-6 max-w-2xl mx-auto">
                Our comprehensive learning platform is under development. Master new skills across AI, business, creative arts, and more with structured courses and learning paths.
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                <Target className="w-5 h-5" />
                <span className="font-medium">8 Learning Paths</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                <Clock className="w-5 h-5" />
                <span className="font-medium">100+ Hours Content</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                <Zap className="w-5 h-5" />
                <span className="font-medium">Interactive Lessons</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/ambassador-program')}
              className="flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-md"
            >
              <Target className="w-5 h-5" />
              <span>Join Ambassador Program</span>
            </button>
            <button
              onClick={() => navigate('/podcasts')}
              className="flex items-center justify-center space-x-2 px-6 py-3 bg-white text-blue-600 border-2 border-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200"
            >
              <Headphones className="w-5 h-5" />
              <span>Explore Podcasts First</span>
            </button>
          </div>
        </motion.div>

        {/* Coming Soon Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8"
        >
          <div className="text-center max-w-2xl mx-auto">
            <div className="w-24 h-24 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <BookOpen className="w-12 h-12 text-blue-600" />
            </div>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Learning Hub is in Development
            </h2>
            
            <p className="text-gray-600 text-lg mb-6">
              We're building an exceptional learning experience with structured courses, hands-on projects, and AI-powered tutoring. Everything you need to master new skills in 2026.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-lg flex items-center justify-center mb-4 mx-auto shadow-md">
                  <Target className="w-6 h-6" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Learning Paths</h3>
                <p className="text-gray-600 text-sm">Structured journeys from beginner to expert</p>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 text-white rounded-lg flex items-center justify-center mb-4 mx-auto shadow-md">
                  <Zap className="w-6 h-6" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">AI-Powered</h3>
                <p className="text-gray-600 text-sm">Personalized learning with AI assistance</p>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-lg flex items-center justify-center mb-4 mx-auto shadow-md">
                  <Clock className="w-6 h-6" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Flexible Schedule</h3>
                <p className="text-gray-600 text-sm">Learn at your own pace, anytime</p>
              </div>
            </div>

            {/* Email Notification Form */}
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-2">
                <Mail className="w-5 h-5 text-blue-600" />
                Get Notified When We Launch
              </h3>
              
              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
                  {error}
                </div>
              )}
              
              {subscribed ? (
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg">
                  <div className="flex items-center justify-center mb-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center">
                      <CheckCircle className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <p className="text-green-700 font-medium">🎉 Thank you! We'll notify you when Learning Hub launches.</p>
                  <p className="text-green-600 text-sm mt-2">
                    You'll receive exclusive early access.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleNotifyMe} className="space-y-4">
                  <div className="flex flex-col sm:flex-row gap-3">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={user?.email || 'Enter your email'}
                      className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required={!user?.email}
                    />
                    <button
                      type="submit"
                      disabled={loading}
                      className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md whitespace-nowrap"
                    >
                      {loading ? 'Subscribing...' : 'Notify Me'}
                    </button>
                  </div>
                  {user?.email && (
                    <p className="text-sm text-gray-600">
                      Using your account email: {user.email}
                    </p>
                  )}
                  <p className="text-gray-500 text-sm">
                    We'll send you an exclusive early access invitation when Learning Hub is ready.
                  </p>
                </form>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default LearningHub;